module.exports = __webpack_public_path__ + "img/ic_discover_communty.ee30374.svg";